<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="请选择任务所属分组">
                <el-select v-model="formInline.task_group" placeholder="请选择任务所属分组">
                    <el-option :label="g.name" :value="g.id" v-for="g in listData.group"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-form-item label="请选择任务执行对象" prop="task_object">
                    <el-select v-model="formInline.task_object" placeholder="请选择任务执行对象">
                        <el-option label="分组任务" value="1"></el-option>
                        <el-option label="设备任务" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form-item>
            <el-form-item>
                <el-form-item label="任务类型" prop="task_type">
                    <el-select v-model="formInline.task_type" placeholder="请选择任务类型">
                        <el-option label="定时任务" value="1"></el-option>
                        <el-option label="环境任务" value="2"></el-option>
                        <el-option label="定时任务&环境任务" value="3"></el-option>
                    </el-select>
                </el-form-item>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" plain icon="el-icon-refresh" @click="refresh()">重置</el-button>
            </el-form-item>
        </el-form>
        <el-form :inline="true" :model="formInline">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">新建任务
                </el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData.tasks" highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;" ref="taskTable">
            <el-table-column align="center" type="selection" width="60"></el-table-column>
            <el-table-column prop="name" label="任务名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="gname" label="所属分组" show-overflow-tooltip></el-table-column>
            <el-table-column prop="method_type" label="执行对象" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.method_type == '1'">分组任务</span>
                    <span v-else-if="scope.row.method_type == '2'">分组任务</span>
                </template>
            </el-table-column>
            <el-table-column prop="task_type" label="执行类型" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.task_type == '1'">定时任务</span>
                    <span v-else-if="scope.row.task_type == '2'">环境任务</span>
                    <span v-else-if="scope.row.task_type == '3'">定时任务&环境人物</span>
                </template>
            </el-table-column>
            <el-table-column sortable prop="add_time1" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">详情</el-button>
                    <el-button size="mini" type="danger" @click="deleteTask(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="70%" @click="closeDialog">
            <div>
                <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <p><span>|</span>基本信息</p>
                    </div>
                    <el-form-item label="任务名称" prop="name" :required="true">
                        <el-input size="small" v-model="editForm.name" auto-complete="off" style="width: 20vw;"
                                  placeholder="任务名称"></el-input>
                    </el-form-item>
                    <el-form-item label="任务分组" prop="g_id" :required="true">
                        <el-select v-model="editForm.g_id" placeholder="请选择分组" style="width: 20vw;">
                            <el-option
                                    v-for="item in groups"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="任务方式" prop="task_method" :required="true">
                        <el-radio v-model="editForm.task_method" label="2">按星期</el-radio>
                        <el-radio v-model="editForm.task_method" label="1">按日期</el-radio>
                    </el-form-item>
                    <div>
                        <div style="margin-left: 2.5vw;" v-if="editForm.task_method == '2'">
                            <el-checkbox-group v-model="weeks" @change="checkWeek">
                                <el-checkbox :label="w" :key="k" v-for="(w,k) in week">{{w}}</el-checkbox>
                            </el-checkbox-group>
                        </div>

                        <el-form-item prop="dates" v-if="editForm.task_method == '1'">
                            <el-date-picker
                                    v-model="dates"
                                    type="dates"
                                    ref="dateSelect"
                                    @change="checkDate()"
                                    value-format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div>
                        <p><span>|</span>时间段设置 <span
                                style="margin-left: 1vw;color: #0052D9;">最多可设置8个时间段，最低设置一个时间段</span></p>

                        <div style="">
                            <div style="display:flex;">
                                <el-form-item label="时间段1" prop="time_section">
                                    <el-time-picker style="width: 20vw;"
                                                    is-range
                                                    v-model="ts1"
                                                    range-separator="至"
                                                    start-placeholder="开始时间"
                                                    end-placeholder="结束时间"
                                                    value-format="HH:mm:ss"
                                                    @change="chooseTimeRange(0)"
                                                    placeholder="选择时间范围">
                                    </el-time-picker>
                                </el-form-item>
                                <el-image src="/static/images/minus-red.png" @click="deleteTimeSection(0)"
                                          style="width: 14px;height: 14px;margin-left: 1vw;margin-top: 2vh;"></el-image>
                            </div>
                            <div style="display:flex;" v-if="tmp_select.indexOf('1') > -1">
                                <el-form-item label="时间段2" prop="ts2">
                                    <el-time-picker style="width: 20vw;"
                                                    is-range
                                                    v-model="ts2"
                                                    range-separator="至"
                                                    start-placeholder="开始时间"
                                                    end-placeholder="结束时间"
                                                    value-format="HH:mm:ss"
                                                    @change="chooseTimeRange(1)"
                                                    placeholder="选择时间范围">
                                    </el-time-picker>
                                </el-form-item>
                                <el-image src="/static/images/minus-red.png" @click="deleteTimeSection(1)"
                                          style="width: 14px;height: 14px;margin-left: 1vw;margin-top: 2vh;"></el-image>
                            </div>
                            <div style="display:flex;" v-if="tmp_select.indexOf('2') > -1">
                                <el-form-item label="时间段3" prop="ts3">
                                    <el-time-picker style="width: 20vw;"
                                                    is-range
                                                    v-model="ts3"
                                                    range-separator="至"
                                                    start-placeholder="开始时间"
                                                    end-placeholder="结束时间"
                                                    value-format="HH:mm:ss"
                                                    @change="chooseTimeRange(2)"
                                                    placeholder="选择时间范围">
                                    </el-time-picker>
                                </el-form-item>
                                <el-image src="/static/images/minus-red.png" @click="deleteTimeSection(2)"
                                          style="width: 14px;height: 14px;margin-left: 1vw;margin-top: 2vh;"></el-image>
                            </div>
                            <div style="display:flex;" v-if="tmp_select.indexOf('3') > -1">
                                <el-form-item label="时间段4" prop="ts4">
                                    <el-time-picker style="width: 20vw;"
                                                    is-range
                                                    v-model="ts4"
                                                    range-separator="至"
                                                    start-placeholder="开始时间"
                                                    end-placeholder="结束时间"
                                                    value-format="HH:mm:ss"
                                                    @change="chooseTimeRange(3)"
                                                    placeholder="选择时间范围">
                                    </el-time-picker>
                                </el-form-item>
                                <el-image src="/static/images/minus-red.png" @click="deleteTimeSection(3)"
                                          style="width: 14px;height: 14px;margin-left: 1vw;margin-top: 2vh;"></el-image>
                            </div>
                            <div style="display:flex;" v-if="tmp_select.indexOf('4') > -1">
                                <el-form-item label="时间段5" prop="ts5">
                                    <el-time-picker style="width: 20vw;"
                                                    is-range
                                                    v-model="ts5"
                                                    range-separator="至"
                                                    start-placeholder="开始时间"
                                                    end-placeholder="结束时间"
                                                    value-format="HH:mm:ss"
                                                    @change="chooseTimeRange(4)"
                                                    placeholder="选择时间范围">
                                    </el-time-picker>
                                </el-form-item>
                                <el-image src="/static/images/minus-red.png" @click="deleteTimeSection(4)"
                                          style="width: 14px;height: 14px;margin-left: 1vw;margin-top: 2vh;"></el-image>
                            </div>
                            <div style="display:flex;" v-if="tmp_select.indexOf('5') > -1">
                                <el-form-item label="时间段6" prop="ts2">
                                    <el-time-picker style="width: 20vw;"
                                                    is-range
                                                    v-model="ts6"
                                                    range-separator="至"
                                                    start-placeholder="开始时间"
                                                    end-placeholder="结束时间"
                                                    value-format="HH:mm:ss"
                                                    @change="chooseTimeRange(5)"
                                                    placeholder="选择时间范围">
                                    </el-time-picker>
                                </el-form-item>
                                <el-image src="/static/images/minus-red.png" @click="deleteTimeSection(5)"
                                          style="width: 14px;height: 14px;margin-left: 1vw;margin-top: 2vh;"></el-image>
                            </div>
                            <div style="display:flex;" v-if="tmp_select.indexOf('6') > -1">
                                <el-form-item label="时间段7" prop="ts7">
                                    <el-time-picker style="width: 20vw;"
                                                    is-range
                                                    v-model="ts7"
                                                    range-separator="至"
                                                    start-placeholder="开始时间"
                                                    end-placeholder="结束时间"
                                                    value-format="HH:mm:ss"
                                                    @change="chooseTimeRange(6)"
                                                    placeholder="选择时间范围">
                                    </el-time-picker>
                                </el-form-item>
                                <el-image src="/static/images/minus-red.png" @click="deleteTimeSection(6)"
                                          style="width: 14px;height: 14px;margin-left: 1vw;margin-top: 2vh;"></el-image>
                            </div>
                            <div style="display:flex;" v-if="tmp_select.indexOf('7') > -1">
                                <el-form-item label="时间段8" prop="ts8">
                                    <el-time-picker style="width: 20vw;"
                                                    is-range
                                                    v-model="ts8"
                                                    range-separator="至"
                                                    start-placeholder="开始时间"
                                                    end-placeholder="结束时间"
                                                    value-format="HH:mm:ss"
                                                    @change="chooseTimeRange(7)"
                                                    placeholder="选择时间范围">
                                    </el-time-picker>
                                </el-form-item>
                                <el-image src="/static/images/minus-red.png" @click="deleteTimeSection(7)"
                                          style="width: 14px;height: 14px;margin-left: 1vw;margin-top: 2vh;"></el-image>
                            </div>
                        </div>

                        <div style="margin-left: 2.5vw;" @click="addTimeSection"
                             v-if="editForm.time_section.length < 8">
                            <el-image src="/static/images/plus-blue.png"></el-image>
                            <span style="color: #0052D9;">添加时间段</span>
                        </div>
                    </div>

                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    import {deleteTask, groups, saveTask, tasks} from "../../api/userMG";

    const selectable_week = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
    export default {
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                operatorVisible: false, //控制操作员页面显示与隐藏
                showEdit: false,
                title: '添加任务',
                dates: '',
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10,
                    task_object: '',
                    task_type: '',
                    task_group: ''
                },
                week: selectable_week,
                weeks: [],
                editForm: {
                    id: 0,
                    name: '',
                    g_id: '',
                    task_method: '2',
                    time_section: [{}],
                },
                ts1: [],
                ts2: [],
                ts3: [],
                ts4: [],
                ts5: [],
                ts6: [],
                ts7: [],
                ts8: [],
                tmp_select: ['0'],
                time_selected: [
                    {'start_time': '08:00:00', 'end_time': '20:00:00'},
                    {},
                    {},
                    {},
                    {},
                    {},
                    {},
                    {}
                ],
                time_section_num: 8,
                groups: [],
                rules: {
                    name: [
                        {required: true, message: '请输入任务名称', trigger: 'blur'}
                    ],
                    task_method: [
                        {required: true, message: '请选择任务方式', trigger: 'blur'}
                    ]
                },
                listData: [], //用户数据
                managers: [],
                uids: [],
                start: 1,
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                }
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 创建完毕
         */
        created() {
            this.getdata(this.formInline)
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            getdata(parameter) {
                this.loading = true
                tasks(parameter).then(res => {
                    this.listData = res.result
                    this.loading = false

                    this.pageparm.currentPage = this.formInline.page
                    this.pageparm.pageSize = this.formInline.limit
                    this.pageparm.total = res.total
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.page = parm.currentPage
                this.formInline.limit = parm.pageSize
                this.formInline.pageSize = parm.pageSize
                this.getdata(this.formInline)
            },
            // 搜索事件
            search() {
                this.getdata(this.formInline)
            },
            chooseDateRange() {

            },
            getTaskMethod() {
                if (this.editForm.task_method == '1') {
                    this.$refs.dateSelect.focus()
                } else {
                    this.$refs.dateSelect.blur()
                }
            },
            checkDate() {

            },
            checkWeek() {
                let str = '';
                this.weeks.forEach(item => {

                })
            },
            chooseTimeRange(index) {
                if (index == 0) {
                    this.time_selected[0] = {'start_time': this.ts1[0], 'end_time': this.ts1[1]}
                } else if (index == 1) {
                    this.time_selected[1] = {'start_time': this.ts2[0], 'end_time': this.ts2[1]}
                } else if (index == 2) {
                    this.time_selected[2] = {'start_time': this.ts3[0], 'end_time': this.ts3[1]}
                } else if (index == 3) {
                    this.time_selected[3] = {'start_time': this.ts4[0], 'end_time': this.ts4[1]}
                } else if (index == 4) {
                    this.time_selected[4] = {'start_time': this.ts5[0], 'end_time': this.ts5[1]}
                } else if (index == 5) {
                    this.time_selected[5] = {'start_time': this.ts6[0], 'end_time': this.ts6[1]}
                } else if (index == 6) {
                    this.time_selected[6] = {'start_time': this.ts7[0], 'end_time': this.ts7[1]}
                } else if (index == 7) {
                    this.time_selected[7] = {'start_time': this.ts8[0], 'end_time': this.ts8[1]}
                }
            },
            addTimeSection() {
                this.editForm.time_section.push({})
                this.tmp_select.push(this.tmp_select.length.toString())
            },
            deleteTimeSection(index) {
                if (this.editForm.time_section.length <= 1) {
                    this.$message.error('至少保留一个时间段！')
                } else {
                    this.editForm.time_section.splice(index, 1)
                    this.tmp_select.splice(index, 1)
                    this.time_selected[index] = {}
                }
            },
            getGroups() {
                groups().then(res => {
                    if (res.code == 200) {
                        this.groups = res.result
                    }
                })
            },
            //显示编辑界面
            handleEdit: function (row) {
                this.editFormVisible = true
                this.getGroups()
                if (row != undefined) {
                    this.title = '编辑任务'
                    let tmp_week = []
                    let tmp_section = []
                    if (row.weeks.indexOf(',')) {
                        row.weeks.split(',').forEach(item => {
                            tmp_week.push(this.week[parseInt(item)])
                        })
                    } else {
                        tmp_week.push(row.weeks)
                    }

                    row.time_section = JSON.parse(row.time_section)
                    for (let i = 0; i < row.time_section.length; i++) {
                        tmp_section.push(i.toString())
                        if (i == 0) {
                            this.ts1 = [row.time_section[0].start_time, row.time_section[0].end_time]
                        } else if (i == 1) {
                            this.ts2 = [row.time_section[1].start_time, row.time_section[1].end_time]
                        } else if (i == 2) {
                            this.ts3 = [row.time_section[2].start_time, row.time_section[2].end_time]
                        } else if (i == 3) {
                            this.ts4 = [row.time_section[3].start_time, row.time_section[3].end_time]
                        } else if (i == 4) {
                            this.ts5 = [row.time_section[4].start_time, row.time_section[4].end_time]
                        } else if (i == 5) {
                            this.ts6 = [row.time_section[5].start_time, row.time_section[5].end_time]
                        } else if (i == 6) {
                            this.ts7 = [row.time_section[6].start_time, row.time_section[6].end_time]
                        } else if (i == 7) {
                            this.ts8 = [row.time_section[7].start_time, row.time_section[7].end_time]
                        }
                    }
                    this.weeks = tmp_week
                    this.dates = JSON.parse(row.dates).join(',')
                    this.uids = row.m_id
                    this.editForm = {
                        id: row.id,
                        name: row.name,
                        g_id: row.gid,
                        task_method: row.task_method.toString(),
                        time_section: row.time_section
                    }
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        let row = this.editForm
                        let tmp_section = [];
                        this.time_selected.forEach(item => {
                            if (item.start_time != undefined) {
                                tmp_section.push({start_time: item.start_time, end_time: item.end_time})
                            }
                        })
                        let params = {
                            id: row.id,
                            name: row.name,
                            g_id: row.g_id,
                            time_section: JSON.stringify(tmp_section),
                            task_method: row.task_method,
                        }
                        if (row.task_method == 1) {
                            params.dates = this.dates
                        } else if (row.task_method == 2) {
                            let tmp_week = [];
                            this.weeks.forEach(item => {
                                this.week.forEach((item1, k) => {
                                    if (item == item1) {
                                        tmp_week.push(k)
                                    }
                                })
                            })
                            params.weeks = tmp_week.sort()
                        }
                        saveTask(params)
                            .then(res => {
                                this.editFormVisible = false
                                this.loading = false
                                if (res.code == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功！'
                                    })
                                    this.getdata()
                                    this.$refs['editForm'].resetFields()
                                    this.resetData()
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: '保存失败！'
                                    })
                                }
                            })
                            .catch(err => {
                                this.editFormVisible = false
                                this.loading = false
                                this.$message.error('任务保存失败，请稍后再试！')
                            })
                    } else {
                        return false
                    }
                })
            },
            resetData() {
                this.dates = ''
                this.weeks = []
            },
            // 删除任务
            deleteTask(row) {
                this.$confirm('确定要删除吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteTask({id: row.id})
                        .then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '任务已删除!'
                                })
                                this.getdata(this.formInline)
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '任务删除失败!'
                                })
                            }
                        })
                        .catch(err => {
                            this.loading = false
                            this.$message.error('任务删除失败，请稍后再试！')
                        })
                })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            // 关闭编辑、增加弹出框
            closeDialog(formName) {
                this.editFormVisible = false
                this.$refs[formName].resetFields()
            },
            refresh() {
                this.formInline.task_group = ''
                this.formInline.task_object = ''
                this.formInline.task_type = ''
                this.getdata(this.formInline)
            },
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .el-dialog {
        margin-top: -20px !important;
    }
</style>







// WEBPACK FOOTER //
// src/views/task/index.vue